import { configurationApiRef } from '@agilelab/plugin-wb-configuration-common';
import { useEnabledFeatures } from '@agilelab/plugin-wb-platform';
import { WitboostCommercialModule } from '@agilelab/plugin-wb-platform-common';
import { useApi } from '@mainstage/core-plugin-api';
import { useQuery } from '@tanstack/react-query';

export function useMarketplaceSemanticAvailability() {
  const configurationApi = useApi(configurationApiRef);
  const { loading, error, isCommercialModuleLicensed } = useEnabledFeatures();
  const licensed =
    !loading &&
    !error &&
    isCommercialModuleLicensed(WitboostCommercialModule.Witty);
  const enabled = useQuery({
    queryKey: ['marketplace', 'embeddingSearch', 'enabled'],
    queryFn: () =>
      configurationApi.get<boolean>({
        namespace: 'marketplace',
        key: 'embeddingSearch.enabled',
      }),
    enabled: licensed,
    retry: false,
  });

  return {
    semanticAvailable: licensed && enabled.isSuccess && enabled.data === true,
    semanticLicenseLoading: loading || (licensed && enabled.isLoading),
    semanticLicenseError: error,
  };
}
